'use strict';

angular.module('far.admin')
    .controller('MountainPeakEditController', function ($log, $window, form, mountainPeaks, mountainRegions) {
        var vm = {
            progress: true,
            mountainPeakForm: form('mountainPeak'),
            model: null,
            init: function (id) {
                vm.model = mountainPeaks.get(id, function () {
                    vm.mountainPeakForm.$fields.mountain_area.model = vm.model.mountain_area;

                    vm.progress = false;
                });
            },
            submit: function () {
                vm.model.save()
                    .then(function (response) {
                        $window.location.href = Routing.generate('admin_mountain_view', {id: response.data.mountain.id});
                    }, function (response) {
                        $log.error(response);
                        
                        vm.alerts.push({
                            type: 'danger',
                            message: 'Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.'
                        });
                    });
            },
            mountain_area: null,
            alerts: [],
            closeAlert: function (index) {
                vm.alerts.splice(index, 1);
            }
        };

        vm.mountainPeakForm
            .addField('name', null, {
                options: {
                    placeholder: 'Название'
                },
                label: 'Название вершины:'
            })
            .addField('description', 'textarea', {
                label: 'Описание:'
            })
            .addField('mountain_area', 'mountainAreaSelect', {
                validators: {
                    required: true
                },
                fieldData: {
                    labelRegion: 'Регион',
                    labelArea: 'Район'
                }
            }, mountainRegions.list)
            .addField('height', 'number', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Высота'
                },
                label: 'Высота вершины:'
            })
            .addField('longitude', null, {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Долгота'
                },
                label: 'Долгота:'
            })
            .addField('latitude', null, {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Широта'
                },
                label: 'Широта:'
            });

        return vm;
    });